export default __webpack_public_path__ + "static/media/premios-sipat-nexa.11b6f5bd.png";